import type {
  CareStateProblemT,
  ClinicianSuggestionViewT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

export type SuggestionProblemGroup = {
  key: string;
  label: string;
  suggestions: ClinicianSuggestionViewT[];
};

export type SuggestionGrouping = {
  groups: SuggestionProblemGroup[];
  ungrouped: ClinicianSuggestionViewT[];
};

export function groupSuggestionsByProblem(
  suggestions: ClinicianSuggestionViewT[],
  problems: Pick<CareStateProblemT, 'id' | 'title'>[]
): SuggestionGrouping {
  const problemsById = new Map(problems.map((problem) => [problem.id, problem]));
  const groupsByKey = new Map<string, SuggestionProblemGroup>();
  const ungrouped: ClinicianSuggestionViewT[] = [];

  for (const suggestion of suggestions) {
    const placement = suggestion.placement;
    const problemId = placement?.care_state_problem_id;
    const provisionalLabel = placement?.provisional_problem_label;
    let key: string;
    let label: string;

    if (problemId && !provisionalLabel) {
      const problem = problemsById.get(problemId);
      if (!problem) {
        ungrouped.push(suggestion);
        continue;
      }
      key = `care-state:${problemId}`;
      label = problem.title;
    } else if (provisionalLabel && !problemId) {
      key = `provisional:${provisionalLabel}`;
      label = provisionalLabel;
    } else {
      ungrouped.push(suggestion);
      continue;
    }

    const group = groupsByKey.get(key);
    if (group) {
      group.suggestions.push(suggestion);
    } else {
      groupsByKey.set(key, { key, label, suggestions: [suggestion] });
    }
  }

  return { groups: [...groupsByKey.values()], ungrouped };
}
